import { render } from "./InternalInfoSidebar.vue?vue&type=template&id=21989728&scoped=true"
import script from "./InternalInfoSidebar.vue?vue&type=script&lang=js"
export * from "./InternalInfoSidebar.vue?vue&type=script&lang=js"

import "./InternalInfoSidebar.vue?vue&type=style&index=0&id=21989728&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21989728"]])

export default __exports__